// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k0Hg","toggle":"styles_toggle__3eQ3F","preview":"styles_preview__2oeqY"};